<template>
  <div id="teamAssess" ><!-- v-loading="loading" -->
    <v-header title="团队考核"></v-header>
    <div class="conH"></div>
    <div class="main-div">
      <el-row type="flex" class="title" justify="center">
        <el-col :span="24">
          <div>
            <span class="topLeft">团队考核
            </span>

            <span class="topRight" >
                考核时间
                <el-date-picker
                    :editable='false'
                    :clearable='false'
                    v-model="month"
                    type="month"
                    placeholder="选择月"
                    :picker-options="pickerOptions0"
                    >
                </el-date-picker>
            </span>
          </div>
        </el-col>
      </el-row>

    <div class="middleDataTable">

      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-table
            :data="teamAssessInfoList"
            style="width: 100%"
            :border="false"
            :fit="true"
            >
            <el-table-column
                prop="pid"
                label="业务编码"
                min-width="50"
                align="center"
                >
            </el-table-column>
            <el-table-column
                prop="psnName"
                label="姓名"
                min-width="40"
                >
            </el-table-column>
            <el-table-column
                prop="typeFlag"
                label="考核类型"
                min-width="40"
                >
            </el-table-column>

             <el-table-column
                prop="rankName"
                label="考核前职级"
                min-width="70"
                >
            </el-table-column>
             <el-table-column
                prop="conFirmRankName"
                label="考核后职级"
                min-width="70"
                >
            </el-table-column>

             <el-table-column
                prop="aam101"
                label="FYC"
                min-width="60"
                >
            </el-table-column>

            <el-table-column
                prop="conFirmChgTypeNo"
                label="考核结果"
                min-width="30">
            </el-table-column>

            <el-table-column
                prop="assStartDate"
                label="考核始期"
                min-width="50"
                >
            </el-table-column>
             <el-table-column
                prop="assEndDate"
                label="考核止期"
                min-width="50"
                >
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      </div>

       <el-row type="flex" class="row-bg" justify="center">
            <el-col class="pages">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next, jumper"
                :total="itemCount"
                :page-size="20">
              </el-pagination>
            </el-col>

      </el-row>

    </div>
  </div>
</template>

<script>
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
      loading: true,
      pid: '',
      itemCount: 0,
      maxDate: '',
      getTeamTreeReq: {
        agentNum: '',
        level: 'T'
      },
      agentNum: '',
      month: '',
      req: {
        month: '',
        pid: '',
        searchType: 'T',
        startIndex: '0',
        limit: '20',
        orderBy: 'conFirmChgTypeNo desc,assStartDate asc'
      },
      result: '',
      currentPage: 1,

      teamAssessInfoVo: {
        pid: '', // 业务编码
        psnName: '', // 代理人名称
        sheetFlag: '', // 考核类型
        conFirmChgTypeNo: '', // 考核结果 S-成功 F-失败
        rankName: '', // 考核前职级,
        conFirmRankName: '', // 考核后职级名称
        assStartDate: '', // 考核开始时间
        assEndDate: '' // 考核结束时间
      },
      teamAssessInfoList: [],
      pickerOptions0: {
        disabledDate (time) {
          let now = new Date() //当前日期
          let nowYear = now.getFullYear() //当前年
          let lastMonthDate = new Date() //上月日期
          lastMonthDate.setDate(1)
          //alert(lastMonthDate)
          lastMonthDate.setMonth(lastMonthDate.getMonth())
          let lastMonth = lastMonthDate.getMonth()
          if (lastMonth == 0) {
            nowYear = nowYear - 1
            lastMonth = 12
          }
          let lastMonthStartDate = new Date(nowYear, lastMonth, 1)
        //   console.log(lastMonthStartDate)
          return time.getTime() > lastMonthStartDate.getTime()
        }
      }

    }
  },
  mounted () {

  },
  created () {

  },
  activated () {
    this.month = new Date()
    this.initReq()
  },
  watch: {
    '$route': 'initReq',
    month: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.req.startIndex = '0'
        this.search()
      }
    }
  },
  methods: {
    search () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
        // target: document.querySelector('#getPolicyList')
      })
      // this.loading = true,
      this.req.month = this.formatter(this.month)

      let that = this
      api.getTeamAssessment(this.req, function (res) {
        if (res.data.data && res.data.data.itemCount != 0) {
          that.teamAssessInfoList = res.data.data.assessReport
          that.itemCount = res.data.data.itemCount - '0'
          for (var i = 0; i < that.teamAssessInfoList.length; i++) {
            // that.teamAssessInfoList[i].sheetFlag = (that.teamAssessInfoList[i].sheetFlag === 'S' ? '维持' : '晋升')
            // that.teamAssessInfoList[i].conFirmChgTypeNo = (that.teamAssessInfoList[i].conFirmChgTypeNo === 'R' ? '晋升' : (
            //   that.teamAssessInfoList[i].conFirmChgTypeNo === 'D' ? '降级' :(
            //     that.teamAssessInfoList[i].conFirmChgTypeNo === 'T' ? '解除合同' : (
            //       that.teamAssessInfoList[i].conFirmChgTypeNo === 'S' ? '维持' : '-'
            //     )
            //   )
            // ))

            that.teamAssessInfoList[i].assEndDate = that.teamAssessInfoList[i].assEndDate.substring(0, that.teamAssessInfoList[i].assEndDate.indexOf(' '))
            that.teamAssessInfoList[i].assStartDate = that.teamAssessInfoList[i].assStartDate.substring(0, that.teamAssessInfoList[i].assStartDate.indexOf(' '))
          }
          loading.close()
        }else {
          loading.close()
        }
      })
    },
    handleCurrentChange (val) {
      // 改变分页参数
      this.currentPage = val
      this.req.startIndex = (this.currentPage - 1) * this.req.limit + ''
      this.search()
    },
    getMaxDate () {
      let currentDate = new Date()
      let year = currentDate.getFullYear()
      let month = currentDate.getMonth() + 1

      if (month + 2 > 12) {
        year++
        month = month - 12
      } else {
        month = month + 2
      }
      return new Date(year, month - 1)
    },

    formatter (value) {
      let result = ''
      if (value) {
        let year = value.getFullYear()
        let month = value.getMonth() + 1
        if (month < 10) {
          month = '0' + month
        }
        result = year + '' + month
      }
      // console.log(result)
      return result
    },
    initReq () {
      console.log('===========' + this.$route.params.pid)
      this.req.pid = this.$route.params.pid
      this.search()
    },
    getTeamTree () {
      var that = this
      api.post(this.getTeamTreeReq, function (res) {
        that.team = res.data.data
        console.log(that.team)
        if (that.team.teamCode.substring(0, 1) === 'Q') {
          that.teamTreeType = 'Q'
          let areaName = that.team.teamName
          that.dept[areaName] = []
          that.dept[areaName].push('请选择')
          for (let i = 0; i < that.team.teamTree.length; i++) {
            let deptTree = that.team.teamTree[i]
            that.dept[areaName].push(deptTree.teamName)
            let deptName = deptTree.teamName
            that.group[deptName] = []
            that.group[deptName].push('请选择')
            for (let j = 0; j < deptTree.teamTree.length; j++) {
              let groupTree = deptTree.teamTree[j]
              that.group[deptName].push(groupTree.teamName)
            }
          }
          console.log(JSON.stringify(that.dept))
          console.log(JSON.stringify(that.group))
        } else if (that.team.teamCode.substring(0, 1) === 'B') {
          that.teamTreeType = 'B'
          let areaName = ''
          that.dept[areaName] = []
          that.dept[areaName].push(that.team.teamName)
          let deptName = that.team.teamName
          that.group[deptName] = []
          that.group[deptName].push('请选择')
          for (let j = 0; j < that.team.teamTree.length; j++) {
            let groupTree = that.team.teamTree[j]
            that.group[deptName].push(groupTree.teamName)
          }
          console.log(JSON.stringify(that.dept))
          console.log(JSON.stringify(that.group))
        } else {
          that.teamTreeType = 'Z'
          let deptName = ''
          that.group[deptName] = []
          that.group[deptName].push(that.team.teamName)
          console.log(JSON.stringify(that.dept))
          console.log(JSON.stringify(that.group))
        }
        that.teamColumns = [
          {
            values: Object.keys(that.dept) ? Object.keys(that.dept) : '',
            className: 'column1'
          },
          {
            values: Object.keys(that.dept) ? Object.keys(that.group) : '',
            className: 'column2'
          },
          {
            values: Object.values(that.group)[0] ? Object.values(that.group)[0] : '',
            className: 'column3'
          }
        ]
      })
    },
    teamChange (picker, values) {
      // console.log(values)
      picker.setColumnValues(1, this.dept[values[0]] ? this.dept[values[0]] : '')
      picker.setColumnValues(2, this.group[values[1]] ? this.group[values[1]] : '')
    },
    teamConfirm (values) {
      // 重置分页参数
      this.req.startIndex = -this.req.limit
      // console.log(values)
      console.log(this.team)
      console.log(this.teamTreeType)
      if (this.teamTreeType === 'Q') {
        this.teamType = 'AREA'
        this.agentNum = this.team.leadAgentNum
        for (let i = 0; i < this.team.teamTree.length; i++) {
          let deptTree = this.team.teamTree[i]
          if (values[1] !== '请选择' && values[1] === deptTree.teamName) {
            this.teamType = 'DEPT'
            this.agentNum = deptTree.leadAgentNum
            for (let j = 0; j < deptTree.teamTree.length; j++) {
              let groupTree = deptTree.teamTree[j]
              if (values[2] !== '请选择' && values[2] === groupTree.teamName) {
                this.teamType = 'GROUP'
                this.agentNum = groupTree.leadAgentNum
              }
            }
          }
          if (values[1] === '请选择') {
            this.agentNum = ''
          }
        }
      }
      if (this.teamTreeType === 'B') {
        console.log(this.team)
        this.teamType = 'DEPT'
        this.agentNum = this.team.leadAgentNum
        console.log(this.agentNum)
        for (let j = 0; j < this.team.teamTree.length; j++) {
          let groupTree = this.team.teamTree[j]
          if (values[2] !== '请选择' && values[2] === groupTree.teamName) {
            this.teamType = 'GROUP'
            this.agentNum = groupTree.leadAgentNum
          }
        }
      }
      if (this.teamTreeType === 'Z') {
        this.teamType = 'GROUP'
        this.agentNum = this.team.leadAgentNum
      }

      let areaInfo = values[0] ? values[0] + '-' : ''
      let deptInfo = values[1] ? values[1] + '-' : ''
      let groupInfo = values[2] ? values[2] : ''
      this.teamInfo = areaInfo + deptInfo + groupInfo
      this.teamShow = false
    }

  }
}

</script>

<style scoped>
.main-div{
    margin: 10px;
}
.title{
  margin: 20px;
}
.topLeft{
  float: left;
}
.topRight{
    float: right;
    /* width: 10%;
    height: 30px; */
}
.middleDataTable{
  /* box-shadow: 1px 2px 5px 1px rgba(1, 1, 1, 0.3); */
  -webkit-box-flex: 1;
  box-sizing: border-box;

}

/* tr{
  border: none;
  border-color: transparent;
} */

/* .el-table__row{
  border: none;
} */

.text::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color:#f2f2f2;
}

.el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid transparent !important;
}
.el-table thead {
    color: red;
    font-weight: 500;
}
.pages{
  display:flex;
  justify-content: center;
  align-items:center;
  background-color: #ffffff;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/teamAssess.vue